// extracted by mini-css-extract-plugin
module.exports = {"switch-address-form":"addressForm_switch-address-form__3OeJE"};